module.exports = __webpack_public_path__ + "static/media/icon-medium-organic.cf870c93.svg";